// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "大学物理（下)",
      "tec": "李海丽",
      "week": "1-9,11-15周",
      "add": "教学楼A座225电力"
    },
    {
      "sub": "固体物理",
      "tec": "刘莉莹",
      "week": "1-9,11-15周",
      "add": "教学楼D座215经管"
    },
    0,
    {
      "sub": "马克思主义基本原理",
      "tec": "李丹",
      "week": "1-9,13-15周",
      "add": "教学楼A座421机械"
    },
    0
  ],
  "2": [
    [
      {
        "sub": "能源电力工程英语（上）",
        "tec": "张育智",
        "week": "1-14周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "25动核新2-1",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼E座418法律"
      },
      {
        "sub": "25动核新2-3",
        "tec": "孟庆双",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25动核新2-2",
        "tec": "杜薇",
        "week": "1-14周",
        "add": "教学楼B座121自控"
      },
      {
        "sub": "25动核新2-4",
        "tec": "贺静",
        "week": "1-14周",
        "add": "教学楼D座125经管"
      },
      {
        "sub": "25动核新1-1",
        "tec": "刘妍",
        "week": "1-14周",
        "add": "教学楼B座319能动"
      },
      {
        "sub": "25动核新1-4",
        "tec": "冯冬惠",
        "week": "1-14周",
        "add": "教学楼B座220能动"
      },
      {
        "sub": "25动核新1-3",
        "tec": "金品卓",
        "week": "1-14周",
        "add": "实训楼E座310"
      }
    ],
    {
      "sub": "概率论与数理统计",
      "tec": "马婷婷",
      "week": "1-6,8-17周",
      "add": "教学楼C座112教务"
    },
    {
      "sub": "普通化学",
      "tec": "王晗",
      "week": "1-9,11-17周",
      "add": "教学楼D座121新能"
    },
    [
      {
        "sub": "科技文献检索",
        "tec": "白波",
        "week": "1-4周",
        "add": "教学楼D座121新能"
      },
      {
        "sub": "创造性思维与创新方法",
        "tec": "柯昀洁",
        "week": "5-9,11-17周",
        "add": "教学楼C座305教务"
      }
    ],
    {
      "sub": "形势与政策",
      "tec": "王姝",
      "week": "1-4周",
      "add": "教学楼C座311教务"
    }
  ],
  "3": [
    {
      "sub": "创造性思维与创新方法",
      "tec": "柯昀洁",
      "week": "1-4周",
      "add": "教学楼C座305教务"
    },
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "傅瑶",
      "week": "1-6,8-17周",
      "add": "教学楼A座422机械"
    },
    0,
    0,
    0
  ],
  "4": [
    0,
    {
      "sub": "大学物理（下)",
      "tec": "李海丽",
      "week": "1-9,11-15周",
      "add": "教学楼A座225电力"
    },
    [
      {
        "sub": "体育（三）",
        "tec": "陈迪",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女乒",
        "tec": "李罡",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "足球",
        "tec": "李欣诺",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女网",
        "tec": "张慧",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女篮",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "健美操",
        "tec": "郝俊",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女排",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男篮",
        "tec": "贾思敏",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男篮",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "搏击",
        "tec": "李庆",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "轮滑",
        "tec": "郝策",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男网",
        "tec": "李灏",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男乒",
        "tec": "李莉",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女羽",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "足球"
      }
    ],
    0,
    {
      "sub": "就业创业指导",
      "tec": "赵明明张莉静",
      "week": "11-15周",
      "add": "教学楼C座114教务"
    }
  ],
  "5": [
    {
      "sub": "概率论与数理统计",
      "tec": "马婷婷",
      "week": "1-6,8-17单周",
      "add": "教学楼C座111教务"
    },
    [
      {
        "sub": "能源电力工程英语（上）",
        "tec": "孟庆双",
        "week": "1-14周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "25动核新2-2",
        "tec": "刘妍",
        "week": "1-14周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "25动核新1-4",
        "tec": "冯冬惠",
        "week": "1-14周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "25动核新1-3",
        "tec": "金品卓",
        "week": "1-14周",
        "add": "教学楼D座125经管"
      },
      {
        "sub": "25动核新1-2",
        "tec": "贺静",
        "week": "1-14周",
        "add": "实训楼E座310"
      },
      {
        "sub": "25动核新1-1",
        "tec": "杜薇",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25动核新2-4",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "25动核新2-3",
        "tec": "张育智",
        "week": "1-14周",
        "add": "实训楼E座418法律"
      }
    ],
    {
      "sub": "马克思主义基本原理",
      "tec": "李丹",
      "week": "1-9,13-15周",
      "add": "教学楼A座325电力"
    },
    {
      "sub": "固体物理",
      "tec": "刘莉莹",
      "week": "1-9,11-15周",
      "add": "教学楼D座121新能"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
